export const DATE_FORMATS = ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'] as const;
export type DateFormat = (typeof DATE_FORMATS)[number];

/** The two languages the PRD names for the mobile app (drivers first). */
export const LANGUAGES = ['en', 'sw'] as const;
export type Language = (typeof LANGUAGES)[number];
